import './css/style.css';

import 'main.core';
import ClassRouter from "./js/ClassRouter";
import OrderManagerMake from "./js/OrderManager/OrderManagerMake";

export {
    ClassRouter,
    OrderManagerMake
}


/** Injection javascript to the page **/

BX.ready(() => ClassRouter.init(location.pathname));

